import { Component, EventEmitter, Input, Output, OnChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../../../app.service';
import { Service } from '../org-vdc-wizard.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
let $ = require('jquery');


@Component({
  selector: 'desc-vdc',
  styles: [require('../org-vdc.wizard.scss')],
  template: require('./desc-vdc.html'),
    providers: [
    Service, TranslateService
  ]
})

export class DescVdc {
  @ViewChild('descVdc') descVdc: NgForm;
  @Input() descVdcData: Object;
  @Input() orgVdcId: string = '';
  @Input() editData: any;
  @Input() isWizardOpen: boolean = false;
  @Input() stepId: number;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

  private selectedItem: any ;
  private tableData: any = [];
  private subscribeHandler;
  private isTranslationready: boolean = true;
  private isFirstLoad: boolean = false;
  private orgList: any;
  private vdcOption = {
      'name': 'Select a VDC',
      'id': -1
  };

  private dataModel = {
    orgVdcName: '',
    selectedOrgId: '',
    name: '',
    description: '',
    stepId: -1,
    isStepValid: false
  };



  reset() {
    this.dataModel = {
      orgVdcName: '',
      selectedOrgId: '',
      name: '',
      description: '',
      stepId: -1,
      isStepValid: false
    };
    this.vdcOption = {
      'name': 'Select a VDC',
      'id': -1
    }
  }

  ngOnInit() {
    this.getOrgList();
  }

  ngOnChanges(changes) {
    if ( !this.isWizardOpen ) {
      this.reset();
      this.descVdc.form.reset();
    }
    if (this.stepId >= 0) {
      this.dataModel.stepId = this.stepId;
    }
  }

  constructor(public appState: AppState,
            public service: Service,
            private translate: TranslateService) {
      translate.use(GlobalVariables.LOCALE);
   }

  getOrgList() {
      this.subscribeHandler = this.service.getOrgList()
      .subscribe(
        tableData => {
          this.orgList = tableData;
        },
        error => this.service.logError(error, 'get Orgs error'),
        () => this.service.logOperationCompleted('get Orgs Completed')
      );
  }


  selOrgVdcChange(event) {
    if (event) {
      if (event.id !== -1) {
        this.dataModel.selectedOrgId = event.id;
        this.dataModel.orgVdcName = event.name;
      } else {
        this.dataModel.selectedOrgId = '';
        this.dataModel.orgVdcName = '';
      }
      this.emitData();
    }
  }

  emitData() {
    if (this.dataModel.orgVdcName === '' || this.dataModel.name === '') {
        this.dataModel.isStepValid = false;
    } else {
        this.dataModel.isStepValid = true;
    }
    this.stepEventEmitter.emit(this.dataModel);
  }
};



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/steps/desc-vdc.component.ts